const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles((theme) => ({
    title: {
        marginTop: theme.spacing(10),
    },
    text: {
        margin: theme.spacing(2),
        marginTop: theme.spacing(5)
    },
    buttonContainer: {
        width: '100%',
        marginTop: 'auto',
        marginBottom: theme.spacing(2),
    },
    button: {
        width: '75%',
    },
}));

export default useStyles;